import React from 'react';
import { Heading } from '@abyss/web/ui/Heading';
import { Text } from '@abyss/web/ui/Text';
import { ContentWidthWrapper } from '@pass-frontend/abyss/common/components/content-width-wrapper/ui';
import { useFacilityBasedOnLocation } from '@pass-frontend/abyss/common/components/gym-search-wrapper/data-bridge';
import { GymSearchWrapper } from '@pass-frontend/abyss/common/components/gym-search-wrapper/ui';
import { useIntl } from '@pass-frontend/common/i18n';
import { env } from '@pass-frontend/features/configuration/util';

const { FF_ENABLE_LANDING_PAGE_NEW_LAYOUT } = env();

interface GymSearchProps {
  isCommercial?: boolean;
  showPremiumFilter?: boolean;
}

const gymSearchDisclaimer = {
  'abyss-text-root': {
    color: '$gray7',
    display: 'block',
    fontSize: '$lg',
    fontWeight: '$normal',
    lineHeight: '24px',
    margin: '$xs 0 0',
  },
};

export const GymSearch: React.FC<GymSearchProps> = (props) => {
  const { t } = useIntl();
  const { isCommercial = false } = props;

  const isNewLayoutSpacingEnabled =
    isCommercial && FF_ENABLE_LANDING_PAGE_NEW_LAYOUT;

  return (
    <ContentWidthWrapper
      css={{
        'abyss-flex-root': {
          padding: isNewLayoutSpacingEnabled
            ? '$lg 0 $xl'
            : '$core-spacing-700 0',
          '& .gymSearch-informationText': {
            visibility: isNewLayoutSpacingEnabled ? 'visible' : 'hidden',
          },
        },
      }}
    >
      <Heading
        offset={1}
        textAlign="center"
        css={{ 'abyss-heading-root': { marginBottom: '$core-spacing-700' } }}
        id="gym-search-link"
      >
        {t('gymSearch.landing.title')}
        {!isNewLayoutSpacingEnabled && (
          <Text css={gymSearchDisclaimer}>
            {t('gymSearch.landing.gymSearchDisclaimer')}
          </Text>
        )}
      </Heading>
      <GymSearchWrapper
        facilityDataProvider={useFacilityBasedOnLocation}
        {...props}
      />
    </ContentWidthWrapper>
  );
};
